import React, { useState } from 'react';
import './ContactDetails.css';

const ContactDetails = () => {
  return (
    <div className="CD-Container">
      {/* Address 1 */}
      <div className="address1">
        <h5>
          Ground floor <br />
          470 St Kilda Rd <br />
          Melbourne <br />
          VIC 3004 <br />          
          Australia <br />
          science@datadisca.com<br />
        </h5>        
      </div>

      
    </div>
  );
};

export default ContactDetails;
